<template>
  <div class="user-login">
    <div class="user-header">
      <img src="../assets/login1.png" @click="$router.replace('/')" alt="">
      <p>F F博客注册</p>
    </div>

    <div class="login-form">
      <div class="login-reg">
        <span @click="$router.replace('/user_login')" :style="index == 0 ? '' : 'color: #1727b4; font-size: 16px;'">去登录</span>
        <span :style="index == 1 ? '' : 'color: #1727b4; font-size: 16px;'">注册</span>
      </div>

      <div class="">
        <el-form status-icon :model="emailForm" ref="emailForm" label-width="100px" class="demo-dynamic">
          <el-form-item
            prop="email"
            label="邮箱"
            :rules="[
              { required: true, message: '请输入邮箱地址', trigger: 'blur' },
              { type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change'] }
            ]">
            <span v-if="isCode" style="position: absolute; right: 30px; z-index: 99; color: #1727b4; padding: 0 10px;">{{msg}}</span>
            <span v-else style="position: absolute; right: 30px; z-index: 99; background-color: #1727b4; cursor: pointer; border-radius: 10px; color: #fff; padding: 0 10px;" @click="submitCode('emailForm')">获取验证码</span>
            <el-input v-model="emailForm.email" placeholder="请输入邮箱"></el-input>
          </el-form-item>
        </el-form>
        <el-form status-icon :model="registerForm" ref="registerForm" label-width="100px" class="demo-dynamic">
          <el-form-item
            label="验证码"
            prop="code"
            :rules="{
              required: true, message: '验证码不能为空', trigger: 'blur'
            }">
            <el-input type="number" v-model="registerForm.code" placeholder="请输入验证码"></el-input>
          </el-form-item>
          <el-form-item
            label="用户名"
            prop="u_name"
            :rules="{
              required: true, message: '用户名不能为空', trigger: 'blur'
            }">
            <el-input type="text" v-model="registerForm.u_name" placeholder="请输入用户名" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item
            label="密码"
            prop="pawd"
            :rules="{
              required: true, message: '密码不能为空', trigger: 'blur'
            }">
            <el-input type="password" v-model.trim="registerForm.pawd" placeholder="请输入密码"></el-input>
          </el-form-item>
          <el-form-item style="text-align: center;">
            <el-button style="width: 80%" type="primary" @click="submitRegisterForm('registerForm')">注册</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
  let timer = null
  export default {
    name: 'user_login', //登录
    metaInfo () {
      return {
        title:'F F博客登录'
      }
    },

    data () {
      return {
        index: 1,
        isCode: false,
        isClick: true,
        msg: '',
        registerForm: {
          u_name: '',
          pawd: '',
          code: ''
        },
        emailForm: {email: ''}
      }
    },

    beforeDestroy () {
      if(timer) clearInterval(timer)
    },

    methods: {
      submitRegisterForm (registerForm) {
        this.$refs[registerForm].validate((valid) => {
          this.$refs['emailForm'].validate((valid1) => {
            if (valid && valid1) {
              if(!this.registerForm.u_name.replace(/\s*/g, "")) {
                this.$message.warning('用户名不能全部为空格！')
                return false
              }
              if(!this.isClick) return false
              this.isClick = false
              this.$http.post('user/user_register', {obj: window.btoa(window.encodeURIComponent(JSON.stringify(Object.assign(this.registerForm, this.emailForm, {u_time: new Date().getTime()}))))}, true).then(res => {
                this.isClick = true
                if(res.data.code == 0){
                  this.$message.success(res.data.msg)
                  this.$router.replace('/user_login')
                } else {
                  this.$message.warning(res.data.msg)
                }
              }).catch(err => {
                this.isClick = true
                this.$message.error('网络有误！')
              })
            } else {
              return false
            }
          })
        })
      },

      submitCode (emailForm) {
        this.$refs[emailForm].validate((valid) => {
          if (valid) {
            if(!this.isClick) return false
            this.isClick = false
            this.$http.post('user/user_code', {obj: window.btoa(window.encodeURIComponent(JSON.stringify({email: this.emailForm.email})))}, true).then(res => {
              this.isClick = true
              if(res.data.code == 0){
                this.isCode = true
                let num = 60
                this.msg = num -- + '秒后重新获取'
                timer = setInterval(() => {
                  console.log(111)
                  this.msg = num -- + '秒后重新获取'
                  if(num <= 0) {
                    clearInterval(timer)
                    this.isCode = false
                  }
                }, 1000)
              } else {
                this.$message.warning(res.data.msg)
              }
            }).catch(err => {
              this.isClick = true
              this.$message.error('网络有误！')
            })
          } else {
            return false
          }
        })
      }
    }
  }
</script>

<style lang="less" scoped>
  .user-login {
    .user-header {
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 20px;
      font-size: 40px;
      font-weight: bold;
      color: #000;
      img {
        margin-right: 20px;
        border-radius: 50%;
        cursor: pointer;
        width: 80px;
        height: 80px;
      }
    }

    .login-form {
      background-color: #fff;
      padding: 30px 0;
      padding-right: 20px;
      box-sizing: border-box;
      margin-bottom: 100px;
      border-radius: 30px;
      box-shadow: 0px 0px 5px 0px #000;
      .login-reg {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-bottom: 20px;
        span {
          padding: 5px;
          font-size: 30px;
          color: #000;
          cursor: pointer;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/register.vue